
import './tinyCartBox.css'
import { useNavigate } from 'react-router-dom';
import { historyCases } from '../../data';

function TinyCartBox({casHistory}) {
    const navigate = useNavigate();
  return (
    <div className='cart-box'>
        <div className="content-cart">
            <div className="line">
                <span>Type :</span>
                <span>{historyCases.filter(item => item.id === casHistory.type)[0]['nom'] }</span>
            </div>
            <div className="line">
                <span>Motif :</span>
                <span>{casHistory.motif}</span>
            </div>
            <div className="line">
                <span>Date :</span>
                <span>{casHistory.createdAt.slice(0, 10)} {casHistory.createdAt.slice(11, 19)}</span>
            </div>
            {/* <div className='button'>
                <span onClick={()=>navigate(`/envois/detail/${idHistory}`)}>Action</span>
            </div> */}
        </div>
    </div>
  )
}

export default TinyCartBox
